import { Component, OnInit } from '@angular/core'
import { CrmAssignee, ProspectScrapeSettings } from '@parkupp/core'
import { ProspectingService } from 'src/app/services/prospecting.service'

@Component({
    selector: 'app-admin-prospecting-settings',
    templateUrl: './admin-prospecting-settings.component.html',
    styleUrls: ['./admin-prospecting-settings.component.scss'],
})
export class AdminProspectingSettingsComponent implements OnInit {
    // Assignees
    assignees: CrmAssignee[] = []
    assigneesLoading = true

    // Scrape settings
    scrape: Partial<ProspectScrapeSettings> = {}
    scrapeLoading = true
    scrapeSaving = false
    scrapeMessage = ''
    scrapeError = ''

    constructor(private prospecting: ProspectingService) {}

    async ngOnInit(): Promise<void> {
        await this.prospecting.ensureMarkAssignee()
        this.loadAssignees()
        this.loadScrapeSettings()
    }

    // ── Assignees ──

    private loadAssignees(): void {
        this.prospecting.listAllAssignees().subscribe({
            next: (list) => {
                this.assignees = list
                this.assigneesLoading = false
            },
            error: () => {
                this.assigneesLoading = false
            },
        })
    }

    async toggleAssignee(assignee: CrmAssignee): Promise<void> {
        const enabled = !assignee.prospectingEnabled
        assignee.prospectingEnabled = enabled
        try {
            await this.prospecting.updateAssigneeProspecting(assignee.$key!, enabled)
        } catch {
            assignee.prospectingEnabled = !enabled
        }
    }

    // ── Scrape Settings ──

    private loadScrapeSettings(): void {
        this.prospecting.getScrapeSettings().subscribe({
            next: (settings) => {
                if (settings) {
                    this.scrape = { ...settings }
                }
                this.scrapeLoading = false
            },
            error: (err) => {
                this.scrapeError = err?.message || 'Failed to load scrape settings'
                this.scrapeLoading = false
            },
        })
    }

    async saveScrapeSettings(): Promise<void> {
        this.scrapeMessage = ''
        this.scrapeError = ''
        this.scrapeSaving = true
        try {
            await this.prospecting.updateScrapeSettings(this.scrape)
            this.scrapeMessage = 'Scrape settings saved'
        } catch (e: any) {
            this.scrapeError = e?.message || 'Failed to save scrape settings'
        } finally {
            this.scrapeSaving = false
        }
    }
}
